<template>
  <div class="Buy" id="Purchase">
    <h1>Purchase</h1>
    <!-- <p><slot></slot></p> -->
    <div class="left" v-scroll-reveal="{ opacity: 0 }">
      <!-- <div class="left" v-scroll-reveal="{ delay: 1200, distance: '40px', origin: 'left' }"> -->
      <!-- <div class="line">License Type: <select><option>License</option></select></div>
      <div class="line">Price: <strong>$1024.<span>00</span></strong></div>
      <div class="line">Quantity: <select><option>1</option><option>2</option><option>3</option></select></div>-->

      <Button
        v-if="
          fields.show_buy_now_button !== '' &&
            overrides &&
            overrides.buy_link_override != ''
        "
        inverse
        half
        text="Buy New Online"
        :href="overrides.buy_link_override"
        newTab
      ></Button>
      <Button
        v-else-if="
          fields.show_buy_now_button !== '' &&
            overrides &&
            overrides.buy_link_override == ''
        "
        inverse
        half
        text="Buy New Online"
        :href="'https://account.carlsonsw.com/purchase?' + tag"
        newTab
      ></Button>
      <Button
        v-else-if="fields.show_buy_now_button !== ''"
        inverse
        half
        text="Buy New Online"
        :href="'https://account.carlsonsw.com/purchase?' + tag"
        newTab
      ></Button>

      <Button
        v-if="
          fields.show_renew_upgrade_button !== '' &&
            overrides &&
            overrides.renew_upgrade_link_override != ''
        "
        inverse
        half
        text="Renew / Upgrade"
        :href="overrides.renew_upgrade_link_override"
        newTab
      ></Button>
      <Button
        v-else-if="
          fields.show_renew_upgrade_button !== '' &&
            overrides &&
            overrides.renew_upgrade_link_override == ''
        "
        inverse
        half
        text="Renew / Upgrade"
        href="https://account.carlsonsw.com/renew"
        newTab
      ></Button>
      <Button
        v-else-if="fields.show_renew_upgrade_button !== ''"
        inverse
        half
        text="Renew / Upgrade"
        href="https://account.carlsonsw.com/renew"
        newTab
      ></Button>

      <Button
        v-if="
          fields.show_get_quote_button !== '' &&
            overrides &&
            overrides.get_quote_link_override != ''
        "
        inverse
        half
        text="Get Quote"
        :href="overrides.get_quote_link_override"
        newTab
      ></Button>
      <Button
        v-else-if="
          fields.show_get_quote_button !== '' &&
            overrides &&
            overrides.get_quote_link_override == ''
        "
        inverse
        half
        text="Get Quote"
        :clickFunction="show"
        newTab
      ></Button>
      <Button
        v-else-if="fields.show_get_quote_button !== ''"
        inverse
        half
        text="Get Quote"
        href="https://account.carlsonsw.com/contact"
        newTab
      ></Button>
      <!-- <Button
        v-else-if="fields.show_get_quote_button !== ''"
        inverse
        half
        text="Get Quote"
        :clickFunction="show"
        newTab
      ></Button>-->
    </div>
    <div class="right" v-scroll-reveal="{ opacity: 0 }">
      <!-- <div class="right" v-scroll-reveal="{ delay: 1200, distance: '40px', origin: 'right' }"> -->
      <a href="tel:16065645028">
        <svg
          width="60px"
          height="131px"
          viewBox="0 0 111 131"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g
            id="Page-1"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g
              id="Hover"
              transform="translate(-287.000000, -1254.000000)"
              fill="#208FCC"
              fill-rule="nonzero"
            >
              <g
                id="noun_818016_cc-copy"
                transform="translate(287.000000, 1254.000000)"
              >
                <path
                  d="M51.3661265,130.613721 C48.8875163,131.335866 46.222627,131.037557 43.9656127,129.785302 C41.7085984,128.533047 40.0471182,126.430966 39.35161,123.947731 L36.8285615,114.908648 L23.1053137,114.908648 C19.564816,114.908648 16.1693279,113.504032 13.665818,111.003801 C11.1623081,108.503569 9.75585085,105.112528 9.75585085,101.576667 L9.75585085,88.0447061 L6.21824319,86.8714918 C3.78588056,86.0652767 1.80808836,84.2698011 0.77312797,81.9283174 C-0.261832417,79.5868338 -0.257515929,76.9175384 0.785011815,74.5794054 L8.28740993,57.7544455 C9.25712653,55.5904054 9.75755846,53.2459989 9.75585085,50.8751434 C9.77522975,29.2477477 23.5398461,10.0175149 44.023922,3 C44.5223019,6.41298711 44.967284,9.89707812 45.3588683,13.452273 C30.126083,19.613204 20.1424132,34.3688422 20.1016846,50.7818195 C20.1078381,54.5901519 19.3071373,58.3566956 17.7521791,61.8340317 L10.7303616,77.5524372 L15.0155392,78.9922911 C18.0295443,79.9833237 20.0650186,82.7959135 20.0616362,85.9649171 L20.0616362,101.656659 C20.0616362,103.335434 21.424337,104.69635 23.1053137,104.69635 L44.5579005,104.69635 L49.1100673,120.694727 L95.0722679,107.58939 L87.4630741,80.9254283 L89.5055419,78.8056434 C97.8815258,70.1252987 101.919087,58.1516495 100.507224,46.1794433 C99.0953614,34.2072371 92.3828451,23.4980089 82.2167352,16.9985799 C81.8963481,12.8390019 81.4958642,8.75052776 81.0152835,4.73315752 C95.5732652,11.2122816 106.220668,24.1666173 109.746534,39.6895024 C113.272401,55.2123876 109.264041,71.4869187 98.9302627,83.6051565 L105.111064,105.256293 C105.830391,107.731597 105.530001,110.3913 104.276644,112.644389 C103.023286,114.897479 100.920783,116.557319 98.4363325,117.255076 L51.3661265,130.613721 Z M43.2890468,80.9972668 C40.4417652,79.2611364 36.8030977,79.6457482 34.3712376,81.9398906 C31.9393775,84.234033 31.303062,87.8823094 32.8117272,90.8812496 C34.3203923,93.8801898 37.6088003,95.5037704 40.8711045,94.8603935 C44.1334087,94.2170165 46.5798271,91.4624394 46.866896,88.1093526 C52.9226752,84.3641172 57.8422739,79.0015249 61.0855338,72.6103732 C68.9128374,74.0722732 76.6832095,69.7903518 79.7217599,62.3407422 C82.7603102,54.8911325 80.2388069,46.3044096 73.6742624,41.7466049 C73.6621602,28.1807463 72.7768639,14.6301114 71.0240038,1.18087814 C68.6627881,0.655240092 66.2667307,0.305409802 63.8550541,0.13419382 C62.6712719,0.0447336219 61.4830726,3.52291303e-06 60.2904562,3.52291303e-06 C57.8875394,-0.000893468137 55.4875408,0.169502044 53.1082552,0.509926652 C55.0295593,13.8776098 56.0170242,27.3659184 56.0632936,40.874368 C51.0872149,43.6394487 47.8211607,48.7566656 47.3752128,54.4867551 C46.929265,60.2168447 49.3634131,65.7889854 53.8503276,69.3092919 C51.4189632,74.0870609 47.7732497,78.1217049 43.2890468,80.9972668 Z"
                  id="Shape"
                />
              </g>
            </g>
          </g>
        </svg>
        <h4>Give Us a Call</h4>
        <h3>1 (606) 564-5028</h3>
      </a>
    </div>
  </div>
</template>

<script>
import Rule from "@/atoms/Rule";
import Button from "@/atoms/Button";

export default {
  name: "Buy",
  components: { Rule, Button },
  props: {
    title: {
      type: String,
    },
    tag: {
      type: String,
    },
    fields: {
      type: Object,
    },
    overrides: {
      type: Object,
    },
  },
  methods: {
    show() {
      this.$modal.show("quoteModal");
    },
    hide() {
      this.$modal.hide("quoteModal");
    },
  },
};
</script>

<style scoped lang="scss">
.Buy {
  background: white;
  overflow: hidden;
  @extend .cf;
  @extend .limit;
  @extend .destruct;

  color: $blue;
  font-size: 16px;
  letter-spacing: 0.06125em;
  padding-top: 124px;
  padding-bottom: 96px;
  @include smx {
    font-size: 18px;
    padding-top: 96px;
    padding-bottom: 32px;
  }

  .left,
  .right {
    width: 50%;
    float: left;
    @include smx {
      float: none;
      width: auto;
    }
  }

  .left {
    position: relative;
    top: -20px;

    strong {
      color: $navy;
    }

    .line {
      padding-bottom: 12px;
      font-size: 18px;
    }

    .Button {
      margin-top: 16px;
      display: block;
      &:first-of-type {
        margin-top: 0;
      }
    }

    span {
      font-size: 11px;
      top: -3px;
      position: relative;
    }
  }

  .right {
    padding-left: 72px;
    text-align: center;
    position: relative;
    top: -25px;
    border-left: 1px solid $blue;
    padding-bottom: 18px;

    @include smx {
      border-left: 0;
      padding-left: 12px;
      top: 0;
    }

    a {
      display: block;
      text-decoration: none;
      transition: all 0.4s;
      padding-top: 8px;

      h3 {
        padding-top: 6px;
      }

      svg,
      g,
      path {
        color: $navy;
        fill: $navy;
      }

      &:hover {
        color: $navy;
        fill: $navy;
        transition: all 0.4s;
      }
    }
  }

  .Rule {
    padding-top: 32px;
  }

  h1 {
    padding-bottom: 0px;
    font-size: 24px;
    position: relative;
    top: -60px;
    @include smx {
      font-size: 20px !important;
    }
  }

  p {
    color: #333;
    padding-top: 16px;
    line-height: 1.75em;
  }
}
</style>
